<template>
  <div v-show="false">
    <form
      ref="form"

      method="POST"
      action="/api/export.php"
      target="_blank"
    >
      <input
        type="text"
        name="format"
        :value="format"
      ></input>
      <textarea
        name="content"
        :value="contentWithSource"
      ></textarea>
    </form>
    <div
      v-show="false"
      v-if="formatSources"
      ref="sources"
    >
      <lit-list-item-view
        v-for="item in orderedSources"
        :key="item.id"
        :content="item.content"
        :label="item.label"
      ></lit-list-item-view>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  components: {
    LitListItemView: require('./LitListItemView.vue')
  },
  computed: {
    ...mapState({content: state => state.contentHtml}),
    ...mapGetters(['orderedSources'])
  },
  data () {
    return {
      formatSources: false,
      format: 'pdf',
      contentWithSource: ''
    }
  },
  methods: {
    exportSources () {
      let result = []
      let elements = this.$refs.sources.children
      for (var i = 0; i < elements.length; i++) {
        result.push('<p>' + _.escape(elements[i].innerText) + '</p>')
      }
      return result.join('')
    },
    export (format) {
      this.format = format
      this.formatSources = true
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.contentWithSource = this.content + this.exportSources()
          this.$nextTick(() => {
            this.$refs.form.submit()
            this.formatSources = false
          })
        })
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// ExportContainer.vue?4c38b42f